export default __webpack_public_path__ + "static/media/Group1295.d483728b.png";